
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93shQ_mxW8lrR2Z05_IESusN55sVChNNxgWiWz4Cb8LsAMeta } from "/tmp/build_163e7334/pages/Cases/Overview/[id].vue?macro=true";
import { default as _91id_93rxsdshaTXqMpruL9eBvkzpaJzeBMt9iENM47uvIgCTMMeta } from "/tmp/build_163e7334/pages/Service Requests/Overview/[id].vue?macro=true";
import { default as indexVOjY_y_M7DuNhhaqSQZ9PEyDoUR_N_WqM9R_5EWPWvcMeta } from "/tmp/build_163e7334/pages/Cases/Overview/index.vue?macro=true";
import { default as _91id_93lVFxQRZl6UaJNsZz0NXt2wd04RK3MeVM8kyxtEMRbJsMeta } from "/tmp/build_163e7334/pages/Companies/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93hvevyAcQz8bceLrohq_mOERYhXLoWrMFSXkNL2AVq3AMeta } from "/tmp/build_163e7334/pages/Companies/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93gY6FmBs7B8GIIBa_3OPswNjZmw8hLmA7hbwqNEUbsY4Meta } from "/tmp/build_163e7334/pages/Companies/Overview/Sales/[id].vue?macro=true";
import { default as indexpCbDg16wA0C8s0yffWIzBPhJIYR_HNBEcoj_Y7xJrEcMeta } from "/tmp/build_163e7334/pages/Companies/Overview/Activities/index.vue?macro=true";
import { default as indexXVhe9KlxMpyA_qTiEtR34q_mbs1Kaom5tOqx_BJ00noMeta } from "/tmp/build_163e7334/pages/Companies/Overview/Operations/index.vue?macro=true";
import { default as indexDhuiT83FpU8vqVnJL_zI2_XUltDWofs2Tf8WoReGug4Meta } from "/tmp/build_163e7334/pages/Companies/Overview/Sales/index.vue?macro=true";
import { default as OverviewF3b680T10r_r8uC7dFwKt_AU1KDLgy2r3Gpb4iXqrTIMeta } from "/tmp/build_163e7334/pages/Companies/Overview.vue?macro=true";
import { default as _91id_93fUrvPkmlz3sLoe1SDNktqL4XUz_TOpJ2nDhaO8kzN48Meta } from "/tmp/build_163e7334/pages/Home/Overview/Activities/[id].vue?macro=true";
import { default as _91id_936jVkZRoybzwZYfw4Q5HuX3IBulE_qonfWO1p4CNeWQEMeta } from "/tmp/build_163e7334/pages/Home/Overview/Operations/[id].vue?macro=true";
import { default as _91id_933XcyM2VeqM5r_sjcZfNNoo_7xfhIKxkhHbhv2w1LUcMMeta } from "/tmp/build_163e7334/pages/Home/Overview/Sales/[id].vue?macro=true";
import { default as _91id_93r30VZFzNp_E5sTiWocCPsXgZyKWgqb5XokbUsZfjFiMMeta } from "/tmp/build_163e7334/pages/Home/Overview/Splits/[id].vue?macro=true";
import { default as indexTOVQ28gHaLvH3K_xG_PJ_FerjPDiq5B1koQHNCoDFcsMeta } from "/tmp/build_163e7334/pages/Home/Overview/Activities/index.vue?macro=true";
import { default as indexKT9o4I8LzyVwrRDE_xvirH_qYS1Y_aEFiXp21BYEKfkMeta } from "/tmp/build_163e7334/pages/Home/Overview/Operations/index.vue?macro=true";
import { default as indexdxCTesRR6H5gg2n4ulEqhq30g9vu2paGV8eGyEc_D9oMeta } from "/tmp/build_163e7334/pages/Home/Overview/Sales/index.vue?macro=true";
import { default as indexy32BbtBtaVLj70kBn7TIXHgg8RxbrvuyBvws3X4gor4Meta } from "/tmp/build_163e7334/pages/Home/Overview/Splits/index.vue?macro=true";
import { default as Overviewg4nw1daVGnVXEKMmkZkulQgW4DV_ZhRuAnPsCXZ2mlcMeta } from "/tmp/build_163e7334/pages/Home/Overview.vue?macro=true";
import { default as _91id_93oJv9SXeu5Tzl26gPn8B_U0NcL7foYoD9KOQ4yRfvIDYMeta } from "/tmp/build_163e7334/pages/Opportunities/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93jmrURRZfumInTPKJWvMyCZFTIiDGhVCCcXXZGaxzaNwMeta } from "/tmp/build_163e7334/pages/Opportunities/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93k9uF7gxPSEQYJdY3WPL05Z3lyhMbFJKM2muUHAe9PRsMeta } from "/tmp/build_163e7334/pages/Opportunities/Overview/Sales/[id].vue?macro=true";
import { default as indexmE6HUa26qLw2bhNsbb90p9_Rj4kqTlwHk48_NaPXAgIMeta } from "/tmp/build_163e7334/pages/Opportunities/Overview/Activities/index.vue?macro=true";
import { default as indextkAmmNdBStZasnPe235Y_8opWN8JfBPRUD0qOn7Vl_sMeta } from "/tmp/build_163e7334/pages/Opportunities/Overview/Operations/index.vue?macro=true";
import { default as indexLSF6bd6RD5A17JFbQS46_meOEAU09ah_0XWTThE5QcMMeta } from "/tmp/build_163e7334/pages/Opportunities/Overview/Sales/index.vue?macro=true";
import { default as OverviewjBQ_Ju0J8oiOLX51ZYKwUa1PfKlUKyidNdADzCpSmZwMeta } from "/tmp/build_163e7334/pages/Opportunities/Overview.vue?macro=true";
import { default as _91id_93918_O49McvmllhSeaVxYOQzyNDPbx8gNdekQcEn2G5MMeta } from "/tmp/build_163e7334/pages/Orders/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93UM7HNK0Qvd_Q4848dgZ1FwOA29mvJE5aXLk14XPfdEIMeta } from "/tmp/build_163e7334/pages/Orders/Overview/Sales/[id].vue?macro=true";
import { default as indexlFZRXUrT2Y2_4wYF36tGWFHNeCvBA2YjyD6UIqfrtY8Meta } from "/tmp/build_163e7334/pages/Orders/Overview/Activities/index.vue?macro=true";
import { default as index9xWQQ_UJwbMiANfLSFAW11XQ__wz9II9tzOpGrrSOBAMeta } from "/tmp/build_163e7334/pages/Orders/Overview/Sales/index.vue?macro=true";
import { default as Overviewqf8rWD1JyQiRO80MLagaf3iGDEDFx6xO_hQanqDrVDgMeta } from "/tmp/build_163e7334/pages/Orders/Overview.vue?macro=true";
import { default as indexKzF6pJZgg8Ck7WDJxS0qHIZZ1M579P29v_5lQpVNU_oMeta } from "/tmp/build_163e7334/pages/Service Requests/Overview/index.vue?macro=true";
import { default as _91id_93UWdNjoCZOL2C2y8yAenpVxOCqAHwBsYKsecHCO0W_TAMeta } from "/tmp/build_163e7334/pages/Suppliers/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93Ga_dandR0xuckOgYAKzS4E5DkrkR2TRmlEqbeyqO8_MMeta } from "/tmp/build_163e7334/pages/Suppliers/Overview/Sales/[id].vue?macro=true";
import { default as indexO7axceXm4hw33BglNUba8Sl4paS_Vx3BWKqgxX5OsK4Meta } from "/tmp/build_163e7334/pages/Suppliers/Overview/Activities/index.vue?macro=true";
import { default as indexq7MJ5DzijU_M2vK_r5qDlRgpke94diPyRdjkJdBLM50Meta } from "/tmp/build_163e7334/pages/Suppliers/Overview/Sales/index.vue?macro=true";
import { default as Overview76sJXI_BjtgXWKvZi_jGfgSdWdSASgFFhuFbDaaUy4sMeta } from "/tmp/build_163e7334/pages/Suppliers/Overview.vue?macro=true";
import { default as _91id_93Uilkxub8dGrnnt0kHaBMdMT7Pa3_PJPNOOm5mEHgd6oMeta } from "/tmp/build_163e7334/pages/Accounts/[id].vue?macro=true";
import { default as _91id_93Mr0HALfShJGsXARzM_axtZBEx_1EVReo7YNT7Xp7moIMeta } from "/tmp/build_163e7334/pages/Field Sets/[id].vue?macro=true";
import { default as _91id_93i_22SmfJwEeG00ZtjitOrYYaf76CTpgqFFvnwFAzGHkMeta } from "/tmp/build_163e7334/pages/Industries/[id].vue?macro=true";
import { default as _91id_93ixKuxpLQ4j7BVgUvXHEeCntHYsQ7DI7AKCju9HkVEI4Meta } from "/tmp/build_163e7334/pages/Locations/[id].vue?macro=true";
import { default as _91id_93PtkBvomgXPzEVORH2qeGcv42m7cKO8lwFGnWPKuKQSQMeta } from "/tmp/build_163e7334/pages/Product Categories/[id].vue?macro=true";
import { default as _91id_93VB0g2wG4K8EseYIJJ08TS3JaXNe7KNhM5IC9cu7QzPsMeta } from "/tmp/build_163e7334/pages/Product Groups/[id].vue?macro=true";
import { default as _91id_93rjZu5IfNfZuvhYsrrVqI1w9Udr1Qx_SgRfvLfqwanM8Meta } from "/tmp/build_163e7334/pages/Product Subcategories/[id].vue?macro=true";
import { default as _91id_938pcLwZCPgkFTXeZdhVT7UA9gVS7xhCdy_1ZQ_P4wXHMMeta } from "/tmp/build_163e7334/pages/Products/[id].vue?macro=true";
import { default as _91id_93o_G3LEr0hMBw0BFBe9CRbBxmMOW6TzA5h6LDKLrezjwMeta } from "/tmp/build_163e7334/pages/Projects/[id].vue?macro=true";
import { default as _91id_93JWLFxT55CLV4G3OKr3ztuDoZpz6pB9XmSb2EGIYdEYUMeta } from "/tmp/build_163e7334/pages/SupplierProducts/[id].vue?macro=true";
import { default as _91id_93qAJB1fySCFOJTlz9p9ppmWUMr1xZ_z_hF_EqLpdLcGoMeta } from "/tmp/build_163e7334/pages/Team Members/[id].vue?macro=true";
import { default as _91id_93_Pg9i_ftGj1iXl8TrA0cOpIdSuPx_crI_TGp8YeO5NUMeta } from "/tmp/build_163e7334/pages/TSDs/[id].vue?macro=true";
import { default as indexZ7JLW3_lJkSXHaxEaPuVb6lhqZqYD4Qyn8CD4a_ysJQMeta } from "/tmp/build_163e7334/pages/Accounts/index.vue?macro=true";
import { default as indexQLih_9iUc4ufUxXTA_xNi2ZwLF6RWFvn5ZRm79giLBAMeta } from "/tmp/build_163e7334/pages/Case Types/index.vue?macro=true";
import { default as indexJaTtDVmLj2KgwBDuCQWsihAqxE48cWDZe_TS5bOOqqMMeta } from "/tmp/build_163e7334/pages/Cases/index.vue?macro=true";
import { default as indexgBJXZPZ0Cr2OQIfNEcxIUGAsgYQbPbDCcbKL7YHpVJgMeta } from "/tmp/build_163e7334/pages/Companies/index.vue?macro=true";
import { default as indexgOXQjS5VSYZX26X0tiNr6GXP0kQItOv0a3nr6Q8OuXUMeta } from "/tmp/build_163e7334/pages/Company Contact Roles/index.vue?macro=true";
import { default as index_QwGhaXH30YR0Ay2kalQN2_wMpdEM9SGrEeHpTQWLIQMeta } from "/tmp/build_163e7334/pages/Contacts/index.vue?macro=true";
import { default as indexVe1YpKnLQjRezWwm643vSHdFrS_YaeBvI5mg9MS1gmkMeta } from "/tmp/build_163e7334/pages/Dashboard/index.vue?macro=true";
import { default as indexbRB3JCqj70EeqHpjJ9NCrl9UawqnKnjoLN7EB7v2T8AMeta } from "/tmp/build_163e7334/pages/Field Sets/index.vue?macro=true";
import { default as indexI3Q0PnmOvMnYwDGR3mp0x6f45rV_NEuLPu3Cg0tI44kMeta } from "/tmp/build_163e7334/pages/Groups/index.vue?macro=true";
import { default as indexYD6MEJiHXx72al73Ek_E0KZ1TzpawUKzncZ3tHWBa08Meta } from "/tmp/build_163e7334/pages/Home/index.vue?macro=true";
import { default as indexDLvWp87xzcfNbL0AZoVxRz0HTOKTG4eX3hV9rfAKomsMeta } from "/tmp/build_163e7334/pages/Industries/index.vue?macro=true";
import { default as index3xNDfTNjsvL2_7D46t90N_SN5zq6giQ_C97AxVzgQJkMeta } from "/tmp/build_163e7334/pages/Lead Source Campaigns/index.vue?macro=true";
import { default as indexBC3mxRYEO2S4Drg_KeOHoM_SqoFckVCuevNXsjq_gx4Meta } from "/tmp/build_163e7334/pages/Lead Source Contacts/index.vue?macro=true";
import { default as indexOCW_MR0Wdqa8ty_WY7bW2Kb2w5AykIdajZKzs_qydUQMeta } from "/tmp/build_163e7334/pages/Lead Source Events/index.vue?macro=true";
import { default as indexj0yS9PJ4iiybvu8cfeziOndSJRsHsTzuAjzw26TQ_8EMeta } from "/tmp/build_163e7334/pages/Location Types/index.vue?macro=true";
import { default as indexbO12RpDGB52uV7ZKLL5ssddbpxXKnLfHTi_rQ8Ktw8IMeta } from "/tmp/build_163e7334/pages/Login/index.vue?macro=true";
import { default as index_3skQqyBonBD7aWsFKnLiWogu2OSo1AEPe1jmc7cK1EMeta } from "/tmp/build_163e7334/pages/Opportunities/index.vue?macro=true";
import { default as indexRRzEyEZcaioxR95CM_ABnio6YQ40iR5AUPTLJAUSdk8Meta } from "/tmp/build_163e7334/pages/Opportunity Stages/index.vue?macro=true";
import { default as indexJNcZnQsss3ZRM7_kgZIzKfDpSZ_etkfrGgvx9_fzezAMeta } from "/tmp/build_163e7334/pages/Orders/index.vue?macro=true";
import { default as indexicB48Ca8omv4WZgINRv9naVHLuk0vrOIVJtc1hTjoewMeta } from "/tmp/build_163e7334/pages/Payables/index.vue?macro=true";
import { default as index1OqfvtmYuAkn52_jsRXe7sSQ_a_grYCEXKY6xC_03rcMeta } from "/tmp/build_163e7334/pages/Persons/index.vue?macro=true";
import { default as indextJ9AsErjHDm0z44jj44FklQmuQf0UOFj_OQN1KO_JIUMeta } from "/tmp/build_163e7334/pages/Product Categories/index.vue?macro=true";
import { default as indexJ8DEXGGRPpKPasVZVR2CXPgObcAM_eUfP9fyNpwSi_0Meta } from "/tmp/build_163e7334/pages/Product Groups/index.vue?macro=true";
import { default as indexYZqVa1AxUz_tXlq1K094x8k9VigsDx0hXa56_AM8kJcMeta } from "/tmp/build_163e7334/pages/Product Subcategories/index.vue?macro=true";
import { default as indexdHF_gViPxAuX3nzZ3EeOdg98ZUy2ZCquokCs7R0AlxMMeta } from "/tmp/build_163e7334/pages/Projects/index.vue?macro=true";
import { default as indexIMZXGRhW2nMWUtQPG3l_Bby04DXj7oPq3_Scy8XKrBEMeta } from "/tmp/build_163e7334/pages/Receivables/index.vue?macro=true";
import { default as indexoWoBWwbyapcf3ps7DFj2ks8wgLXwWxoX2YPKp_QXvaYMeta } from "/tmp/build_163e7334/pages/Service Request Types/index.vue?macro=true";
import { default as indexeqoWLwGbrp4j2PiY8jWmxdaO68d2Osd8sd0lMEFWdbsMeta } from "/tmp/build_163e7334/pages/Service Requests/index.vue?macro=true";
import { default as indexWER8HgQTBkstJPjGBOdfWJRb3weuBtv7Xcb9KoPJkgsMeta } from "/tmp/build_163e7334/pages/Settings/index.vue?macro=true";
import { default as indexUKHDpTRvSoLAXsHZP4pHXvfso1HngrH6p62cUPUEPnEMeta } from "/tmp/build_163e7334/pages/Supplier Contact Roles/index.vue?macro=true";
import { default as indexRsKSKaVLwcutai30niOu_y3LFYzD3Ypx4jyE2EeYIRoMeta } from "/tmp/build_163e7334/pages/Suppliers/index.vue?macro=true";
import { default as index5C8rtYd1Iftw8jzpOlizvSj7IuT3YGvfGUgQq5kP0sYMeta } from "/tmp/build_163e7334/pages/Team Members/index.vue?macro=true";
import { default as index3Io6Y70tgUj75p2MV1WjPbAIJLzdkcqozRfiOBgT2_8Meta } from "/tmp/build_163e7334/pages/TSD Contact Roles/index.vue?macro=true";
import { default as indexwjeqS3M35_YgAPiGySdS95vZUXuSb21_XopQTNVFr3IMeta } from "/tmp/build_163e7334/pages/TSDs/index.vue?macro=true";
import { default as indexo5YqTacT_WjsEFcLwgTuEd_HSFKtBpIFXxQJiWnw_R4Meta } from "/tmp/build_163e7334/pages/User/index.vue?macro=true";
import { default as indexHxSOg3Ps8jfKjsR5IdcTfmYqdENBPGeIJ_uNI_Gq8TwMeta } from "/tmp/build_163e7334/pages/Users/index.vue?macro=true";
import { default as indexFr_DZeYNhiHUNozhyIUUkkb0_1fG2ycAG0neKbSlEVgMeta } from "/tmp/build_163e7334/pages/index.vue?macro=true";
export default [
  {
    name: "Cases-Overview-id",
    path: "/Cases/Overview/:id()",
    component: () => import("/tmp/build_163e7334/pages/Cases/Overview/[id].vue")
  },
  {
    name: "Service Requests-Overview-id",
    path: "/Service%20Requests/Overview/:id()",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_163e7334/pages/Service Requests/Overview/[id].vue")
  },
  {
    name: "Cases-Overview",
    path: "/Cases/Overview",
    component: () => import("/tmp/build_163e7334/pages/Cases/Overview/index.vue")
  },
  {
    name: "Companies-Overview",
    path: "/Companies/Overview",
    component: () => import("/tmp/build_163e7334/pages/Companies/Overview.vue"),
    children: [
  {
    name: "Companies-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_163e7334/pages/Companies/Overview/Activities/[id].vue")
  },
  {
    name: "Companies-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_163e7334/pages/Companies/Overview/Operations/[id].vue")
  },
  {
    name: "Companies-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_163e7334/pages/Companies/Overview/Sales/[id].vue")
  },
  {
    name: "Companies-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_163e7334/pages/Companies/Overview/Activities/index.vue")
  },
  {
    name: "Companies-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_163e7334/pages/Companies/Overview/Operations/index.vue")
  },
  {
    name: "Companies-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_163e7334/pages/Companies/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Home-Overview",
    path: "/Home/Overview",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview.vue"),
    children: [
  {
    name: "Home-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Activities/[id].vue")
  },
  {
    name: "Home-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Operations/[id].vue")
  },
  {
    name: "Home-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Sales/[id].vue")
  },
  {
    name: "Home-Overview-Splits-id",
    path: "Splits/:id()",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Splits/[id].vue")
  },
  {
    name: "Home-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Activities/index.vue")
  },
  {
    name: "Home-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Operations/index.vue")
  },
  {
    name: "Home-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Sales/index.vue")
  },
  {
    name: "Home-Overview-Splits",
    path: "Splits",
    component: () => import("/tmp/build_163e7334/pages/Home/Overview/Splits/index.vue")
  }
]
  },
  {
    name: "Opportunities-Overview",
    path: "/Opportunities/Overview",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/Overview.vue"),
    children: [
  {
    name: "Opportunities-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/Overview/Activities/[id].vue")
  },
  {
    name: "Opportunities-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/Overview/Operations/[id].vue")
  },
  {
    name: "Opportunities-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/Overview/Sales/[id].vue")
  },
  {
    name: "Opportunities-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/Overview/Activities/index.vue")
  },
  {
    name: "Opportunities-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/Overview/Operations/index.vue")
  },
  {
    name: "Opportunities-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Orders-Overview",
    path: "/Orders/Overview",
    component: () => import("/tmp/build_163e7334/pages/Orders/Overview.vue"),
    children: [
  {
    name: "Orders-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_163e7334/pages/Orders/Overview/Activities/[id].vue")
  },
  {
    name: "Orders-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_163e7334/pages/Orders/Overview/Sales/[id].vue")
  },
  {
    name: "Orders-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_163e7334/pages/Orders/Overview/Activities/index.vue")
  },
  {
    name: "Orders-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_163e7334/pages/Orders/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Service Requests-Overview",
    path: "/Service%20Requests/Overview",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_163e7334/pages/Service Requests/Overview/index.vue")
  },
  {
    name: "Suppliers-Overview",
    path: "/Suppliers/Overview",
    component: () => import("/tmp/build_163e7334/pages/Suppliers/Overview.vue"),
    children: [
  {
    name: "Suppliers-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_163e7334/pages/Suppliers/Overview/Activities/[id].vue")
  },
  {
    name: "Suppliers-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_163e7334/pages/Suppliers/Overview/Sales/[id].vue")
  },
  {
    name: "Suppliers-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_163e7334/pages/Suppliers/Overview/Activities/index.vue")
  },
  {
    name: "Suppliers-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_163e7334/pages/Suppliers/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Accounts-id",
    path: "/Accounts/:id()",
    component: () => import("/tmp/build_163e7334/pages/Accounts/[id].vue")
  },
  {
    name: "Field Sets-id",
    path: "/Field%20Sets/:id()",
    component: () => import("/tmp/build_163e7334/pages/Field Sets/[id].vue")
  },
  {
    name: "Industries-id",
    path: "/Industries/:id()",
    component: () => import("/tmp/build_163e7334/pages/Industries/[id].vue")
  },
  {
    name: "Locations-id",
    path: "/Locations/:id()",
    component: () => import("/tmp/build_163e7334/pages/Locations/[id].vue")
  },
  {
    name: "Product Categories-id",
    path: "/Product%20Categories/:id()",
    component: () => import("/tmp/build_163e7334/pages/Product Categories/[id].vue")
  },
  {
    name: "Product Groups-id",
    path: "/Product%20Groups/:id()",
    component: () => import("/tmp/build_163e7334/pages/Product Groups/[id].vue")
  },
  {
    name: "Product Subcategories-id",
    path: "/Product%20Subcategories/:id()",
    component: () => import("/tmp/build_163e7334/pages/Product Subcategories/[id].vue")
  },
  {
    name: "Products-id",
    path: "/Products/:id()",
    component: () => import("/tmp/build_163e7334/pages/Products/[id].vue")
  },
  {
    name: "Projects-id",
    path: "/Projects/:id()",
    component: () => import("/tmp/build_163e7334/pages/Projects/[id].vue")
  },
  {
    name: "SupplierProducts-id",
    path: "/SupplierProducts/:id()",
    component: () => import("/tmp/build_163e7334/pages/SupplierProducts/[id].vue")
  },
  {
    name: "Team Members-id",
    path: "/Team%20Members/:id()",
    component: () => import("/tmp/build_163e7334/pages/Team Members/[id].vue")
  },
  {
    name: "TSDs-id",
    path: "/TSDs/:id()",
    component: () => import("/tmp/build_163e7334/pages/TSDs/[id].vue")
  },
  {
    name: "Accounts",
    path: "/Accounts",
    component: () => import("/tmp/build_163e7334/pages/Accounts/index.vue")
  },
  {
    name: "Case Types",
    path: "/Case%20Types",
    component: () => import("/tmp/build_163e7334/pages/Case Types/index.vue")
  },
  {
    name: "Cases",
    path: "/Cases",
    component: () => import("/tmp/build_163e7334/pages/Cases/index.vue")
  },
  {
    name: "Companies",
    path: "/Companies",
    component: () => import("/tmp/build_163e7334/pages/Companies/index.vue")
  },
  {
    name: "Company Contact Roles",
    path: "/Company%20Contact%20Roles",
    component: () => import("/tmp/build_163e7334/pages/Company Contact Roles/index.vue")
  },
  {
    name: "Contacts",
    path: "/Contacts",
    component: () => import("/tmp/build_163e7334/pages/Contacts/index.vue")
  },
  {
    name: "Dashboard",
    path: "/Dashboard",
    component: () => import("/tmp/build_163e7334/pages/Dashboard/index.vue")
  },
  {
    name: "Field Sets",
    path: "/Field%20Sets",
    component: () => import("/tmp/build_163e7334/pages/Field Sets/index.vue")
  },
  {
    name: "Groups",
    path: "/Groups",
    component: () => import("/tmp/build_163e7334/pages/Groups/index.vue")
  },
  {
    name: "Home",
    path: "/Home",
    meta: {"middleware":["home-redirect"]},
    component: () => import("/tmp/build_163e7334/pages/Home/index.vue")
  },
  {
    name: "Industries",
    path: "/Industries",
    component: () => import("/tmp/build_163e7334/pages/Industries/index.vue")
  },
  {
    name: "Lead Source Campaigns",
    path: "/Lead%20Source%20Campaigns",
    component: () => import("/tmp/build_163e7334/pages/Lead Source Campaigns/index.vue")
  },
  {
    name: "Lead Source Contacts",
    path: "/Lead%20Source%20Contacts",
    component: () => import("/tmp/build_163e7334/pages/Lead Source Contacts/index.vue")
  },
  {
    name: "Lead Source Events",
    path: "/Lead%20Source%20Events",
    component: () => import("/tmp/build_163e7334/pages/Lead Source Events/index.vue")
  },
  {
    name: "Location Types",
    path: "/Location%20Types",
    component: () => import("/tmp/build_163e7334/pages/Location Types/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: indexbO12RpDGB52uV7ZKLL5ssddbpxXKnLfHTi_rQ8Ktw8IMeta || {},
    component: () => import("/tmp/build_163e7334/pages/Login/index.vue")
  },
  {
    name: "Opportunities",
    path: "/Opportunities",
    component: () => import("/tmp/build_163e7334/pages/Opportunities/index.vue")
  },
  {
    name: "Opportunity Stages",
    path: "/Opportunity%20Stages",
    component: () => import("/tmp/build_163e7334/pages/Opportunity Stages/index.vue")
  },
  {
    name: "Orders",
    path: "/Orders",
    component: () => import("/tmp/build_163e7334/pages/Orders/index.vue")
  },
  {
    name: "Payables",
    path: "/Payables",
    component: () => import("/tmp/build_163e7334/pages/Payables/index.vue")
  },
  {
    name: "Persons",
    path: "/Persons",
    component: () => import("/tmp/build_163e7334/pages/Persons/index.vue")
  },
  {
    name: "Product Categories",
    path: "/Product%20Categories",
    component: () => import("/tmp/build_163e7334/pages/Product Categories/index.vue")
  },
  {
    name: "Product Groups",
    path: "/Product%20Groups",
    component: () => import("/tmp/build_163e7334/pages/Product Groups/index.vue")
  },
  {
    name: "Product Subcategories",
    path: "/Product%20Subcategories",
    component: () => import("/tmp/build_163e7334/pages/Product Subcategories/index.vue")
  },
  {
    name: "Projects",
    path: "/Projects",
    component: () => import("/tmp/build_163e7334/pages/Projects/index.vue")
  },
  {
    name: "Receivables",
    path: "/Receivables",
    component: () => import("/tmp/build_163e7334/pages/Receivables/index.vue")
  },
  {
    name: "Service Request Types",
    path: "/Service%20Request%20Types",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_163e7334/pages/Service Request Types/index.vue")
  },
  {
    name: "Service Requests",
    path: "/Service%20Requests",
    component: () => import("/tmp/build_163e7334/pages/Service Requests/index.vue")
  },
  {
    name: "Settings",
    path: "/Settings",
    component: () => import("/tmp/build_163e7334/pages/Settings/index.vue")
  },
  {
    name: "Supplier Contact Roles",
    path: "/Supplier%20Contact%20Roles",
    component: () => import("/tmp/build_163e7334/pages/Supplier Contact Roles/index.vue")
  },
  {
    name: "Suppliers",
    path: "/Suppliers",
    component: () => import("/tmp/build_163e7334/pages/Suppliers/index.vue")
  },
  {
    name: "Team Members",
    path: "/Team%20Members",
    component: () => import("/tmp/build_163e7334/pages/Team Members/index.vue")
  },
  {
    name: "TSD Contact Roles",
    path: "/TSD%20Contact%20Roles",
    component: () => import("/tmp/build_163e7334/pages/TSD Contact Roles/index.vue")
  },
  {
    name: "TSDs",
    path: "/TSDs",
    component: () => import("/tmp/build_163e7334/pages/TSDs/index.vue")
  },
  {
    name: "User",
    path: "/User",
    component: () => import("/tmp/build_163e7334/pages/User/index.vue")
  },
  {
    name: "Users",
    path: "/Users",
    component: () => import("/tmp/build_163e7334/pages/Users/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/build_163e7334/pages/index.vue")
  }
]